<script setup lang="ts">

import {useCurrentWorkspaceUser} from "~/stores/spaces";
import {addPlanToEnvironment} from "~/calls/subscription";

import type {Currency, PaymentMethod} from "~/types/subscription.types";
const {isOwner} = useCurrentWorkspaceUser()
const {workspaceId, environmentId} = useEnvironment()
const {plan} = useSubscriptionForEnvironment()
const router = useRouter();

const connections = ref(plan.value?.connections || 5)
const loading = ref(false)
const redirecting = ref(false)

const props = defineProps<{
  currency: Currency,
  paymentMethod: PaymentMethod,
  planType: string,
  connections: number,
}>()

const updatePlan = () => {
  loading.value = true
  const finishUrl = `/workspace/${workspaceId.value}/env/${environmentId.value}/subscription?action=buy&connections=${connections.value}&plan=Pro`
  const cancelUrl = `/workspace/${workspaceId.value}/env/${environmentId.value}/subscription?action=canceled`

  addPlanToEnvironment(
      workspaceId.value,
      environmentId.value,
      props.planType,
      props.connections,
      window.location.origin + finishUrl,
      window.location.origin + cancelUrl,
      props.paymentMethod,
  ).then((r) => {
    loading.value = false
    if (!r.success) return
    if (r.result?.url) {
      redirecting.value = true
      setTimeout(() => {
        window.location.href = r.result.url
      }, 2500)
    } else {
      loading.value = false
      router.push(finishUrl)
    }
  }).finally(() => {
    loading.value = false
  })

}

</script>
<template>
  <div v-if="redirecting" class="text-center mt-4">
    <v-progress-linear indeterminate color="primary"></v-progress-linear>
    <p class="text-center mt-2">Redirecting you to our Payment Provider...</p>
  </div>
  <div v-else>
    <v-alert class="my-4">
      <p>
        You will be redirected to our payment provider to complete the payment. You can cancel the process at any time
        and will come back to this page.
      </p>
    </v-alert>
    <div class="d-flex justify-end">
      <v-btn color="primary" @click="updatePlan" :loading="loading"
             :disabled="!isOwner">
        Start your subscription
      </v-btn>
    </div>


  </div>
</template>
